/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IInvoiceDetailsConfig, IInvoiceDetailsProps as IInvoiceDetailsExtentionProps, IInvoiceDetailsResources as IInvoiceDetailsExtentionResources } from '../definition-extensions/invoice-details.ext.props.autogenerated'

import { IInvoiceDetailsViewProps } from '@msdyn365-commerce-modules/invoice-details/src/modules/invoice-details/./invoice-details';

export const InvoiceDetailsView: React.FC<IInvoiceDetailsViewProps & IInvoiceDetailsExtentionProps<IInvoiceDetailsConfig>  & IInvoiceDetailsExtentionResources> = props => {
    const { header, products, paymentDetails, payInvoiceError, config} = props;
    const salesId = props.data.invoiceDetails.result?.SalesId;
    const invoiceOrderId = props.data.invoiceDetails.result?.Id;
    return (
        <Module {...props.moduleProps}>
            {/* @ts-ignore */}
            {salesId && <>{props.resources.salesIdLabel}{salesId}</>}
            {/* @ts-ignore */}
            {invoiceOrderId && <div className="msc-invoice-details__header__invoice-no">{props.resources.invoiceNoIdLabel}{invoiceOrderId}</div>}
            {config && config.gstNumber && <div className="msc-invoice-details__header__gst-no">{props.resources.gstNumberLabel}{config.gstNumber}</div>}
            {header}
            {products}
            {paymentDetails}
            {payInvoiceError}
        </Module>
    );
};

export default InvoiceDetailsView;
